import { useState } from 'react';
import {
  CreateOrgUnitDialogExample,
  DeleteOrgUnitDialogExample,
  EditOrgUnitDialogExample,
  MoveMultipleToTrashDialogExample,
  MoveToTrashDialogExample,
  SetOrgUnitForUsersDialogExample,
} from '../../shared/shared-dialog-examples';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function UiSandboxPage() {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const handleClose = () => setActiveModal(null);

  const mockConfirm = async () => {
    console.log('Confirmed action!');
    await new Promise((resolve) => setTimeout(resolve, 1500));
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        UI Sandbox
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          Move to Trash
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Caution dialogs with <code>actingAs</code> and a warning primary
          button.
        </Typography>

        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button
            variant="contained"
            color="warning"
            onClick={() => setActiveModal('moveToTrash')}
          >
            Move Single Item to Trash
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={() => setActiveModal('moveMultipleToTrash')}
          >
            Move Multiple Items to Trash
          </Button>
        </Stack>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Org Unit Dialog Examples
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Examples using <code>SharedDialog</code>. Form dialogs should set{' '}
          <code>autoFocus</code> on the first input.
        </Typography>

        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button
            variant="outlined"
            onClick={() => setActiveModal('createOrgUnit')}
          >
            Create Org Unit
          </Button>
          <Button
            variant="outlined"
            onClick={() => setActiveModal('editOrgUnit')}
          >
            Edit Org Unit
          </Button>
          <Button
            variant="outlined"
            onClick={() => setActiveModal('setOrgUnitForUsers')}
          >
            Set Org Unit for Users
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => setActiveModal('deleteOrgUnit')}
          >
            Delete Org Unit
          </Button>
        </Stack>
      </Paper>

      <MoveToTrashDialogExample
        open={activeModal === 'moveToTrash'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
      <MoveMultipleToTrashDialogExample
        open={activeModal === 'moveMultipleToTrash'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
      <CreateOrgUnitDialogExample
        open={activeModal === 'createOrgUnit'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
      <EditOrgUnitDialogExample
        open={activeModal === 'editOrgUnit'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
      <SetOrgUnitForUsersDialogExample
        open={activeModal === 'setOrgUnitForUsers'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
      <DeleteOrgUnitDialogExample
        open={activeModal === 'deleteOrgUnit'}
        handleClose={handleClose}
        onConfirm={mockConfirm}
      />
    </Box>
  );
}
